import { FormControl, FormGroup } from "@angular/forms";

export const titleErrors = (formControl: FormControl): string | null => {
    if (formControl.hasError('required')) {
        return 'El título es obligatorio';
    } else if (formControl.hasError('minlength')) {
        return 'El título debe tener al menos 3 caracteres';
    } else if (formControl.hasError('maxlength')) {
        return 'El título no puede exceder los 100 caracteres';
    }
    return null;
}

export const subtitleErrors = (formControl: FormControl): string | null => {
    if (formControl.hasError('required')) {
        return 'El subtítulo es obligatorio';
    } else if (formControl.hasError('minlength')) {
        return 'El subtítulo debe tener al menos 3 caracteres';
    } else if (formControl.hasError('maxlength')) {
        return 'El subtítulo no puede exceder los 255 caracteres';
    }
    return null;
}

export const buttonTextErrors = (formControl: FormControl): string | null => {
    if (formControl.hasError('minlength')) {
        return 'El texto del botón debe tener al menos 1 carácter';
    } else if (formControl.hasError('maxlength')) {
        return 'El texto del botón no puede exceder los 50 caracteres';
    }
    return null;
}

export const buttonUrlErrors = (formControl: FormControl): string | null => {
    if (formControl.hasError('required')) {
        return 'La URL del botón es obligatoria';
    }
    if (formControl.hasError('permissiveUrl')) {
        return 'La URL no es válida';
    }
    return null;
}

export const startDateErrors = (formControl: FormControl): string | null => {
    if (formControl.hasError('required')) {
        return 'La fecha de inicio es obligatoria';
    }
    if (formControl.hasError('startDateBeforeToday')) {
        return 'La fecha de inicio no puede ser anterior a la fecha actual';
    }
    if (formControl.hasError('startDateAfterEndDate')) {
        return 'La fecha de inicio debe ser anterior a la fecha de fin';
    }
    return null;
}

export const endDateErrors = (formControl: FormControl): string | null => {
    if (formControl.hasError('endDateBeforeStartDate')) {
      return 'La fecha de fin debe ser posterior a la fecha de inicio';
    }
    return null;
}
